'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _MenuItemTitleLink = require('./MenuItemTitleLink');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItemTitleNoLink', _styledComponents2.default.span, _MenuItemTitleLink.styles, {
  themePropTypes: _MenuItemTitleLink.themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/LeftNav/MenuItemTitleNoLink.js
// module id = 1589
// module chunks = 2